import React from 'react';
import { Stack } from '@mui/material';
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import { collection, query, where } from 'firebase/firestore';
import firebaseApp from '../../../firebase-app';
import { useProducts } from './utils';
import FirestoreProductsTable from './tables/FirestoreProducts';
import WebhookEventsProducts from './tables/WebhookEventsProducts';

const Products = ({ user, loading }: { user: any; loading: boolean }) => {
  const { products } = useProducts(user?.products);
  const [productWebhookEvents] = useCollectionDataOnce(
    query(collection(firebaseApp.db, 'webhook-events-v2'), where('PersonId', '==', user?.personId))
  );
  if (products) {
    return (
      <Stack spacing={2}>
        <FirestoreProductsTable products={products} loading={loading} />
        <WebhookEventsProducts productWebhookEvents={productWebhookEvents} />
      </Stack>
    );
  }

  return null;
};

export default Products;
